import resume from '../assets/pdf/resume.pdf'
import headerImage from '../assets/png/M.Abdullah.png'

export const headerData = {
    name: 'M. Abdullah',
    title: "Software Engineer",
    desciption:"A passionate Software Engineer with hands-on experience of 4.5 Years as a Full-Stack Mobile Application & Web Developer. I've completed multiple projects based on MERN Stack, Mobile application & Web Development. Skilled in React Native, MERN Stack, Web Development, and Full-Stack Development",
    image: headerImage,
    resumePdf: resume
}
